import { useTranslation } from '@/hooks/useTranslation';
import { AlertCircle } from 'lucide-react';

export const AIDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground py-2">
      <AlertCircle className="size-3 shrink-0" />
      <span>{t('aiChat.disclaimer')}</span>
    </div>
  );
};
